import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { login } from '../../services/authService';
import '../../assets/styles/Login.css';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Usar el servicio de autenticación
      await login({ username, password });
      
      // Redireccionar al dashboard en caso de éxito
      navigate('/');
    } catch (err: any) {
      console.error('Error de inicio de sesión:', err);
      
      // Manejar diferentes tipos de errores
      if (err.response && err.response.status === 401) {
        setError('Credenciales incorrectas. Por favor, verifique su usuario y contraseña.');
      } else if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else if (err.message && err.message.includes('Network Error')) {
        setError('Error de conexión. Verifique que el servidor esté disponible.');
      } else {
        setError('Error al iniciar sesión. Por favor, inténtelo de nuevo más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Reassist</h1>
          <p>Sistema de Gestión de Asistencia Social</p>
        </div>
        
        <div className="alert alert-info mb-3">
          <FontAwesomeIcon icon={faInfoCircle} className="mr-2" /> 
          <strong>Modo desarrollo:</strong> Use usuario <code>admin</code> y contraseña <code>admin</code> para acceder.
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="alert alert-danger">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="username">
              <FontAwesomeIcon icon={faUser} /> Usuario
            </label>
            <input
              type="text"
              id="username"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">
              <FontAwesomeIcon icon={faLock} /> Contraseña
            </label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>© {new Date().getFullYear()} Reassist. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 